// Components/MessagesArea/components/MessagesList.jsx
import React from 'react';
import Message from '../../Message';
import DateSeparator from './DateSeparator';
import { useDateHelpers } from '../hooks/useDateHelpers';

const MessagesList = ({ messages }) => {
    const { isSameDay } = useDateHelpers();

    return (
        <>
            {messages.map((message, index) => {
                const showDateSeparator =
                    index === 0 || !isSameDay(message.timestamp, messages[index - 1].timestamp);
                return (
                    <React.Fragment key={message.id || `msg-${index}-${message.timestamp.getTime()}`}>
                        {showDateSeparator && (
                            <DateSeparator date={message.timestamp} />
                        )}
                        <Message
                            key={`msg-${message.id || message.timestamp.getTime()}-${Math.random().toString(36).substring(2, 9)}`}
                            text={message.text}
                            sender={message.sender}
                            timestamp={message.timestamp}
                            status={message.status}
                            typeMessage={message.type}
                            media_url={message.media_url}
                            caption={message.caption}
                        />
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default MessagesList;